import { ElementDetails } from "@/lib/types";
import { SlackPresenceProps } from "./types";

export const details = {
  name: "SlackPresence",
  description: "Search your team and see who's online in Slack.",
  tags: ["Communication"],
  category: "Slack",
  // Multiple sizes so the right-click "Size" menu appears (it only shows when there is
  // more than one option) — lets a roster be grown. Default is a taller list.
  grid: { default: [3, 5], large: [4, 7] },
  gridNames: { default: "Medium", large: "Large" },
  integrationsUsed: ["slack"],
  defaultProps: {},
} as ElementDetails<SlackPresenceProps>;
